import { ChildrenElement } from "tm/utils";

type LogoAttribute = string | null;

type Logo = {
  href: LogoAttribute;
  imgAlt: LogoAttribute;
  imgSrc: LogoAttribute;
  target: LogoAttribute;
};

function extractLogoAttributes(element: Element) {
  return {
    imgAlt: element.getAttribute("img-alt"),
    imgSrc: element.getAttribute("img-src"),
    href: element.getAttribute("href"),
    target: element.getAttribute("target"),
  } as Logo;
}

export default class extends ChildrenElement<Logo> {
  childTagName = "TM-LOGO";
  extractor = extractLogoAttributes;
}
